import { useCallback, useContext } from "react";

import { GlobalContext } from "../Context/GlobalContext";

const useDriverTracker = () => {
  const { packkyApi } = useContext(GlobalContext);

  const getDriverTrackingUrl = useCallback(
    async ({ orderid = "" } = {}) => {
      const cleanOrderId = String(orderid || "").trim();

      if (!cleanOrderId) {
        throw new Error("Order ID is required.");
      }

      try {
        const payload = {
          orderid: cleanOrderId,
        };

        console.log("Driver Tracker API Payload:", payload);

        const response = await packkyApi.post(
          "/Driver/v2.0/driverTracker",
          payload,
        );

        const responseData = response?.data;

        console.log("Driver Tracker API Response:", responseData);

        if (String(responseData?.responseCode) !== "00") {
          throw new Error(
            responseData?.responseMessage ||
              responseData?.message ||
              "Unable to fetch tracking URL.",
          );
        }

        const trackingUrl = responseData?.data?.[0]?.url;

        if (!trackingUrl) {
          throw new Error("Tracking URL not found.");
        }

        return trackingUrl;
      } catch (apiError) {
        console.error("Driver Tracker API Error:", apiError);

        throw new Error(
          apiError?.response?.data?.responseMessage ||
            apiError?.response?.data?.message ||
            apiError?.message ||
            "Unable to fetch tracking URL.",
        );
      }
    },
    [packkyApi],
  );

  return {
    getDriverTrackingUrl,
  };
};

export default useDriverTracker;
